import { createContext } from 'react'
import type { CustomReportContextType } from './CustomReportContext'

export const InternalCustomerReportContext = createContext<CustomReportContextType | null>(null)
